import { PressNavId } from 'pages/Press/press.strings';
import { defineMessages, FormattedMessage } from '@alltrails/shared/react-intl';
import CommunityStats from 'components/blocks/CommunityStats';
import { NUM_CURATED_TRAILS, NUM_USERS, LOGGED_DISTANCE } from 'constants/CommunityStats';
import { MEDIA_QUERY_SMALL_DOWN } from 'utils/constants/breakpoints';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import * as styles from './styles/styles.module.scss';

import imgLeftJpg from './images/stats-left.jpg';
import imgLeftWebp from './images/stats-left.webp';
import imgLeftAvif from './images/stats-left.avif';
import imgLeftMobileJpg from './images/stats-left-mobile.jpg';
import imgLeftMobileWebp from './images/stats-left-mobile.webp';
import imgLeftMobileAvif from './images/stats-left-mobile.avif';

import imgMiddleJpg from './images/stats-middle.jpg';
import imgMiddleWebp from './images/stats-middle.webp';
import imgMiddleAvif from './images/stats-middle.avif';
import imgMiddleMobileJpg from './images/stats-middle-mobile.jpg';
import imgMiddleMobileWebp from './images/stats-middle-mobile.webp';
import imgMiddleMobileAvif from './images/stats-middle-mobile.avif';

import imgRightJpg from './images/stats-right.jpg';
import imgRightWebp from './images/stats-right.webp';
import imgRightAvif from './images/stats-right.avif';
import imgRightMobileJpg from './images/stats-right-mobile.jpg';
import imgRightMobileWebp from './images/stats-right-mobile.webp';
import imgRightMobileAvif from './images/stats-right-mobile.avif';
import Typography from 'components/Typography';

/* Figma design: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Rebrand%E2%80%93Press%2FAbout%2F404?node-id=1701%3A10751&t=Ehj2ZVmrAOWAcLYQ-1 */

const Stats = () => {
  const IMAGE_ALTS = defineMessages({
    LEFT_IMAGE_ALT: {
      defaultMessage: 'A person sitting on a rock and looking at a waterfall'
    },
    MIDDLE_IMAGE_ALT: {
      defaultMessage: 'A person on a hiking trail with a mountain in the background'
    },
    RIGHT_IMAGE_ALT: {
      defaultMessage: 'A person sitting on a boulder and smiling'
    }
  });

  const {
    formattedDefaultMessages: { LEFT_IMAGE_ALT, MIDDLE_IMAGE_ALT, RIGHT_IMAGE_ALT }
  } = useFormatMessage(IMAGE_ALTS);

  return (
    <div id={PressNavId.About} className={styles.container}>
      <div className={styles.textContainer}>
        <Typography variant="heading700">
          <FormattedMessage defaultMessage="Helping people across the globe get outside" />
        </Typography>
        <p className={styles.description}>
          <FormattedMessage defaultMessage="AllTrails believes that the outside isn't a place to seek, but rather a part of each and every one of us. We help people worldwide plan, live, and share their adventures, from mountain treks to strolls in the park." />
        </p>
      </div>
      <div className={styles.imgContainer}>
        <picture>
          <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={imgLeftMobileAvif} type="image/avif" />
          <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={imgLeftMobileWebp} type="image/webp" />
          <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={imgLeftMobileJpg} type="image/jpg" />
          <source srcSet={imgLeftAvif} type="image/avif" />
          <source srcSet={imgLeftWebp} type="image/webp" />
          <img src={imgLeftJpg} alt={LEFT_IMAGE_ALT} className={styles.leftImg} loading="lazy" />
        </picture>
        <picture>
          <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={imgMiddleMobileAvif} type="image/avif" />
          <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={imgMiddleMobileWebp} type="image/webp" />
          <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={imgMiddleMobileJpg} type="image/jpg" />
          <source srcSet={imgMiddleAvif} type="image/avif" />
          <source srcSet={imgMiddleWebp} type="image/webp" />
          <img src={imgMiddleJpg} alt={MIDDLE_IMAGE_ALT} className={styles.middleImg} loading="lazy" />
        </picture>
        <picture>
          <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={imgRightMobileAvif} type="image/avif" />
          <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={imgRightMobileWebp} type="image/webp" />
          <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={imgRightMobileJpg} type="image/jpg" />
          <source srcSet={imgRightAvif} type="image/avif" />
          <source srcSet={imgRightWebp} type="image/webp" />
          <img src={imgRightJpg} alt={RIGHT_IMAGE_ALT} className={styles.rightImg} loading="lazy" />
        </picture>
      </div>
      <CommunityStats curatedTrails={NUM_CURATED_TRAILS} fellowExplorers={NUM_USERS} loggedDistanceMeters={LOGGED_DISTANCE} />
    </div>
  );
};

export default Stats;
